import {
  Box,
  Button,
  Table,
  TableBody,
  Checkbox,
  TextField,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  IconButton,
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import "./Data.css";
import Alert from "../../../components/ui/Alert";
import CollapseSection from "../../../components/ui/CollapseSection";
import {
  AddNewAnalyzeDataSource,
  SaveAnalyzeDataSource,
  getChartDataForData,
  setState,
} from "../analyzeSlice";


export default function DataTable() {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    tableData,
    selectedScenarioID,
    selectedDataCustomerIds,
    duration,
    selectedDataProductIds,
    allCustomersSelected,
    searchFilterText
  } = state;

  const [selected, setSelected] = useState(
    tableData?.map((data) => data.dataSourceID)
  );

  const [tableRows, setTableRows] = useState(tableData);
  const isSelected = (id) => selected.indexOf(id) !== -1;
  const [isAdding, setIsAdding] = useState(false);
  const [newRow, setNewRow] = useState({});
  const [isRowEditing, setIsRowEditing] = useState({});
  const [editedData, setEditedData] = useState({});
  const [searchText, setSearchText] = useState("");

  const handleSort = (column) => {
    const originalColumn = headerMapping[column] || column; // Convert back to normal header
   
    const isAsc = orderBy === originalColumn && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(originalColumn);
  
    const sortedData = [...tableRows].sort((a, b) => {
      const aValue = a[originalColumn] === "" ? null : isNaN(a[originalColumn].replace(/,/g, "")) ? a[originalColumn].replace(/,/g, "") : Number(a[originalColumn].replace(/,/g, ""));
      const bValue = b[originalColumn] === "" ? null : isNaN(b[originalColumn].replace(/,/g, "")) ? b[originalColumn].replace(/,/g, "") : Number(b[originalColumn].replace(/,/g, ""));
     
      if (aValue === null) return 1;
      if (bValue === null) return -1;
  
      if (aValue < bValue) return isAsc ? -1 : 1;
      if (aValue > bValue) return isAsc ? 1 : -1;
  
      return 0;
    });
  
    setTableRows(sortedData);
  };
  

  const displayAlert = (alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: alertMessage,
    });

    setTimeout(() => {
      clearAlert();
    }, [2000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
    dispatch(setState("searchFilterText",value));
  };
  useEffect(() => {
    setTableRows(tableData);
  }, [tableData]);

  useEffect(() => {
    let filteredRows = tableData;

    if (searchText !== "") {
      const searchLowercase = searchText.toLowerCase();
      filteredRows = filteredRows.filter((row) => {
        return row.dataSourceName.toLowerCase().includes(searchLowercase);
      });
    }

    setTableRows(filteredRows);
  }, [searchText]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = tableData.map((n) => n.dataSourceID);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  useEffect(() => {
    setSelected(tableData?.map((data) => data.dataSourceID));
  }, [tableData]);

  const handleClick = (event, id,isDisabled) => {
    if(isDisabled){
      return;
    }
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };


  // Function to handle the edit button click
  const handleEditClick = (dataSourceID) => {
    setIsRowEditing({ ...isRowEditing, [dataSourceID]: true });
  };

  const getMonthNumber = (month) => {
    const months = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };
    return months[month.toLowerCase()];
  };

  const transformData = (data, scenarioID) => {
    // Extract the keys that include a month and year, and sort them
    const dateKeys = Object.keys(data)
      .filter((key) =>
        key.match(
          /\b(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\b \d{4}/i
        )
      )
      .sort();
      const monthToNumber = (month) => {
        const monthDict = {
            jan: 1,
            feb: 2,
            mar: 3,
            apr: 4,
            may: 5,
            jun: 6,
            jul: 7,
            aug: 8,
            sep: 9,
            oct: 10,
            nov: 11,
            dec: 12
        };
        return monthDict[month.toLowerCase()] || 0;
      };
      const sortedDates = dateKeys.sort((a, b) => {
        const [monthA, yearA] = a.split(' ');
        const [monthB, yearB] = b.split(' ');
        return (
            monthToNumber(monthA) - monthToNumber(monthB)
        );
      });
      const sortedYear = sortedDates.sort((a, b) => {
        const [monthA, yearA] = a.split(' ');
      const [monthB, yearB] = b.split(' ');
      return (
        parseInt(yearA) - parseInt(yearB)
      );
    });

    const startDateKey = sortedYear[0];
    const endDateKey =  sortedYear[sortedYear.length - 1];

    // Convert month names to numbers
    const startMonth = getMonthNumber(startDateKey.split(" ")[0]);
    const endMonth = getMonthNumber(endDateKey.split(" ")[0]);
    const startYear = startDateKey.split(" ")[1];
    const endYear = endDateKey.split(" ")[1];

    const transformedData = {
      DataSourceID: data.dataSourceID.toString(),
      ScenarioID: scenarioID,
      StartDate: `${startMonth}/1/${startYear}`,
      EndDate: `${endMonth}/1/${endYear}`,
      DataSourceRows: [],
    };

    dateKeys.forEach((key) => {
      const month = getMonthNumber(key.split(" ")[0]);
      const year = key.split(" ")[1];
      const period = `${month}/1/${year}`;
      transformedData.DataSourceRows.push({
        DataSourceID: data.dataSourceID.toString(),
        ScenarioID: scenarioID,
        Period: period,
        Value: parseInt(removeComma(data[key]), 10),
      });
    });

    return transformedData;
  };
  const removeComma=(str)=> {
    let formattedString = "";
    for (let i = 0; i < str.length; i++) {
       if (str[i] !== ",") {
          formattedString += str[i];
       }
    }
    return formattedString;
 }

  // Function to handle the save button click
  const handleSaveClick = (dataSourceID) => {
    const obj = {
      customerIds: selectedDataCustomerIds,
      duration: duration,
      isAllCustomerSelected: allCustomersSelected,
      productIds: selectedDataProductIds,
      scenarioID: selectedScenarioID,
    };

    const scenarioID = selectedScenarioID;
    // Implement save logic here
    const transformed = transformData(editedData[dataSourceID], scenarioID);

    dispatch(SaveAnalyzeDataSource(transformed)).then(() => {
      dispatch(getChartDataForData(obj));
    });

    setIsRowEditing({ ...isRowEditing, [dataSourceID]: false });
  };

  // Function to handle the cancel button click
  const handleCancelClick = (dataSourceID) => {
    // Implement cancel logic here
    setIsRowEditing({ ...isRowEditing, [dataSourceID]: false });
  };

  useEffect(() => {
    const finalSelected = selected.filter((val) => val >= 0);
    dispatch(setState("selectedDataPoints", finalSelected));
  }, [selected]);

  // Create a new object with empty values
  const emptyValuesObject = {};
  for (const key in tableData[0]) {
    if (key !== "dataSourceID" && key !== "localNo" && key !== "avgValue")
      emptyValuesObject[key] = ""; // You can also use an empty string ('') if needed
  }

  const convertObject = (originalObj, scenarioId) => {
    const months = {
      jan: "1",
      feb: "2",
      mar: "3",
      apr: "4",
      may: "5",
      jun: "6",
      jul: "7",
      aug: "8",
      sep: "9",
      oct: "10",
      nov: "11",
      dec: "12",
    }; // Add more months as needed
    let result = {
      DataSourceName: originalObj.dataSourceName,
      DataSourceRows: [],
    };

    for (let key in originalObj) {
      if (key.includes("20")) {
        let monthYear = key.split(" ");
        let month = months[monthYear[0].toLowerCase()];
        let year = monthYear[1];
        result.DataSourceRows.push({
          ScenarioID: scenarioId,
          Period: `${month}/1/${year}`,
          Value: Number(originalObj[key]),
        });
      }
    }

    return result;
  };

  const handleSaveNewRow = () => {
    if (newRow.dataSourceName === null || newRow.dataSourceName === "") {
      displayAlert("Please enter the DataSource Name");
      return;
    }

    if (newRow.dataSourceName != "") {
      const obj = {
        customerIds: selectedDataCustomerIds,
        duration: duration,
        isAllCustomerSelected: allCustomersSelected,
        productIds: selectedDataProductIds,
        scenarioID: selectedScenarioID,
      };

      const scenarioId = selectedScenarioID;
      const resultObj = convertObject(newRow, scenarioId);

      setIsAdding(false);
      setNewRow({});
      dispatch(AddNewAnalyzeDataSource(resultObj)).then(() => {
        dispatch(getChartDataForData(obj));
      });
    }
  };

  const handleCancelNewRow = () => {
    setIsAdding(false);
    setNewRow({});
  };

  const handleChange = (event, fieldName) => {
    if(!Number.isNaN(Number(removeComma(event.target.value)))){
      setNewRow({ ...newRow, [fieldName]: event.target.value });
    }else{
      return;
    }
  };

  const handleEditChange = (event, dataSourceID, header) => {
    if(Number.isNaN(Number(removeComma(event.target.value)))){
      return;
    }
    const value = event.target.value;
    if (editedData[dataSourceID] === undefined) {
    // Update the entire row's data in the editedData state
      setEditedData({
        ...editedData,
        [dataSourceID]: {
          ...tableData.find((row) => row.dataSourceID === dataSourceID), // Get the current row's data
          [header]: value, // Update the changed field
        },
      });
    }else{
      setEditedData({
        ...editedData,
        [dataSourceID]: {
          ...editedData[dataSourceID],
          [header]: value,
        },
      });
    }
    // const updatedList = [...tableData];
    // const index = updatedList.findIndex((item) => item.dataSourceID === dataSourceID);
    // updatedList[index][header] = value;
    // dispatch(setState("tableData", updatedList));
  };

  // Exclude 'dataSourceID' and 'LocalNo' from the headers
  const headerMapping = {};

    const headers =
      tableData.length > 0
        ? Object.keys(tableData[0]).filter(
            (header) => header !== "dataSourceID" && header !== "localNo"
          )
        : [];

    const capitalizedHeaders = headers.map((item) => {
      const formattedHeader = (item.charAt(0).toUpperCase() + item.slice(1)).replace(
        /([A-Z])/g,
        " $1"
      );
    
      headerMapping[formattedHeader.trim()] = item; // Store the  mapping
    
      return formattedHeader.trim();
    });

  const newRowHeaders =
    tableData.length > 0
      ? Object.keys(tableData[0]).filter(
          (header) =>
            header !== "dataSourceID" &&
            header !== "localNo" &&
            header !== "avgValue"
        )
      : [];

  return (
    <CollapseSection title="Data Source Details">
      <Box sx={{ mt: 3 }}>
        <Grid container columns={5} spacing={3}>
          <Grid item sm={2}>
            <TextField
              variant="outlined"
              label="Filter.."
              value={searchFilterText}
              onChange={handleSearchText}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
        </Grid>
      </Box>
      <br />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table" className="stickyColumn2">
        <TableHead>
        <TableRow>
        <TableCell
                padding="checkbox"
                style={{
                  position: "sticky",
                  zIndex: 4,
                  backgroundColor: '#EEF2F4',
                 // backgroundColor: "white",
                  paddingLeft: "20px",
                  // paddingRight: "20px",
                  // transform: "translate(-15px, 0px)",
                  borderLeft:"1px solid transparent !important",
                }}
              >
                {/* Sticky column */}
                <Checkbox
                  indeterminate={
                    selected.length > 0 && selected.length < tableData.length
                  }
                  checked={
                    tableData.length > 0 && selected.length === tableData.length
                  }
                  onChange={handleSelectAllClick}
                  inputProps={{
                    "aria-label": "select all items",
                  }}
                  sx={{ color: "#005587 !important" }}
                />
              </TableCell>
          {capitalizedHeaders.map((header, index) => (
            <TableCell
              key={header}
              sx={{ textAlign: "center", cursor: "pointer",
               }}
              style={{ backgroundColor: "#EEF2F4" }}
              onClick={() => handleSort(header)} 
            >
              {header}
              {orderBy === headerMapping[header] ? (order === "asc" ? " ↑" : " ↓") : ""}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
          <TableBody sx={{ backgroundColor: "white !important" }}>
            {tableRows.map((row, index) => {
              const isItemSelected = isSelected(row.dataSourceID);
              const isDisabled = row.dataSourceID < 0;
              const isEditable = row.dataSourceID >= 1000;
              const isEditing = isRowEditing[row.dataSourceID] || false;
              return (
                <>
                  <TableRow
                   sx={{ backgroundColor: "white !important" }}
                    key={row.dataSourceID}
                    hover
                    onClick={(event) => handleClick(event, row.dataSourceID,isDisabled)}
                    role="checkbox"
                    aria-checked={isDisabled||isItemSelected}
                    tabIndex={-1}
                    selected={isDisabled||isItemSelected}
                  >
                    <TableCell
                      style={{
                        backgroundColor: "white",
                        display: "flex",
                        height: "80px",
                         width: "120px",
                      }}
                    >
                      {!isEditing ? (
                        <>
                          <Checkbox
                            checked={isDisabled||isItemSelected}
                            disabled={isDisabled}
                          />
                          {isEditable && (
                            <IconButton
                              onClick={() => handleEditClick(row.dataSourceID)}
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </>
                      ) : (
                        <>
                          <IconButton
                            onClick={() => handleSaveClick(row.dataSourceID)}
                          >
                            <SaveIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => handleCancelClick(row.dataSourceID)}
                          >
                            <CancelIcon />
                          </IconButton>
                        </>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        backgroundColor: "white",
                        //textAlign:"center"
                      }}
                    >
                      {row.dataSourceName}
                    </TableCell>
                    {headers.map(
                      (header) =>
                        header !== "dataSourceName" && (
                          <TableCell key={`${index}-${header}`} sx={{ textAlign: "center", }}>
                            {isEditing && header !== "avgValue" ? (
                              <TextField
                                defaultValue={removeComma(row[header])}
                                type="number"
                                onChange={(event) =>
                                  handleEditChange(
                                    event,
                                    row.dataSourceID,
                                    header
                                  )
                                }
                              />
                            ) : (
                              row[header]
                            )}
                          </TableCell>
                        )
                           
                    )}
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>


      {alert.alertDisplay && (
        <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
      )}
    </CollapseSection>
  );
}